export const getYesNoChipClassName = (value: boolean) =>
  value ? 'bg-info-70 text-info-10' : 'bg-danger-70 text-danger-10';
